// extracted by mini-css-extract-plugin
export default {"title":"Policy_title__txyjk"};